module.exports = __webpack_public_path__ + "img/side-icon-21-off.b0146f95.svg";